import React from 'react'
import { Box, Stack, Text } from '@mantine/core'
import { BRAND_COLOR } from '../../utils/constants'

interface SectionHeaderProps {
  badge: string
  title: string
  subtitle?: string
  centered?: boolean
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ badge, title, subtitle, centered = true }) => {
  return (
    <Stack gap="md" align={centered ? 'center' : 'flex-start'} style={{ textAlign: centered ? 'center' : 'left' }}>
      <Box
        style={{
          display: 'inline-flex',
          padding: '6px 16px',
          borderRadius: '999px',
          backgroundColor: `${BRAND_COLOR}15`,
          border: `1px solid ${BRAND_COLOR}30`,
        }}
      >
        <Text size="sm" fw={500} c={BRAND_COLOR}>
          {badge}
        </Text>
      </Box>

      <Text
        size="2rem"
        fw={700}
        c="#1F2329"
        style={{
          lineHeight: 1.3,
          maxWidth: centered ? '800px' : '100%',
        }}
      >
        {title}
      </Text>

      {subtitle && (
        <Text
          size="md"
          c="#64748B"
          style={{
            lineHeight: 1.6,
            maxWidth: centered ? '700px' : '100%',
          }}
        >
          {subtitle}
        </Text>
      )}
    </Stack>
  )
}

export default SectionHeader
